// Models
import { BaseModel } from '../../../woopa-ui/api';
import { Placement } from './';
import { Review } from './';

/**
 * Represents a extinguisher in the app.
 */
export interface Extinguisher extends BaseModel {
  number: string;
  brand: string;
  extType: string;
  capacity: number;
  capacityUom: string;
  chargeExpiration: String;
  htExpiration: String;
  manufacturingDate: String;
  dpsNumber: string;
  // Optional
  installationDate?: String;
  htStatus?: number;
  chargeStatus?: number;
  active?: boolean;
  qrUrl?: string;
  status?: number;
  currentPlacement?: Placement;
  placements?: Placement[];
  lastReview?: Review;
  lastRepair?: any;
}

/**
 * List of extinguisher statuses.
 */
export const EXTINGUISHER_STATUSES = [
  'Correcto',
  'Advertencia',
  'Falla',
  'Pendiente',
  'Nuevo',
  'Eliminado'
];

/**
 * List of extinguishers statuses to filter.
 */
export const EXTINGUISHER_STATUSES_FILTER = [
  'Correcto',
  'Advertencia',
  'Falla',
  'Pendiente'
];

/**
 * List of extinguisher charges.
 */
export const EXTINGUISHER_CHARGE_STATUSES = [
  'Correcto',
  'A vencer',
  'Vencido'
];

/**
 * Type of extinguisher.
 */
export const EXTINGUISHER_TYPES = [
  'PQS',
  'AFFF',
  'K',
  'HCFC',
  'CO2',
  'CO2Alu'
];

/**
 * Capacity types of extinguisher.
 */
export const EXTINGUISHER_CAPACITY_TYPES = [
  'Kg',
  'Lbs',
  'Lts',
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/models/extinguisher.interface.ts